// Theme & palette — Viện Dinh Dưỡng (Official Blue/White)
// Matching http://viendinhduong.vn color scheme
export const font = "'Lexend', sans-serif";
export const mono = "'JetBrains Mono', monospace";

export const P = {
  bg: '#f0f4f8',
  card: '#ffffff',
  border: '#d4e0ed',
  borderLight: '#b8cce0',
  primary: '#0072BC',       // Viện Dinh Dưỡng main blue
  primaryDark: '#005a96',
  primaryLight: '#e8f4fd',
  accent: '#00A651',        // Green accent (nutrition)
  success: '#16a34a',
  warning: '#e67e22',
  danger: '#dc3545',
  orange: '#f39c12',
  purple: '#8e44ad',
  text: '#2c3e50',
  textDim: '#546a7b',
  textMuted: '#8899a6',
  white: '#ffffff',
  inputBg: '#f8fafc',
  headerBg: '#0072BC',      // Blue header like the website
  headerText: '#ffffff',
};
